import React, { useState, useEffect } from "react";
import { getCookiePrefs, saveCookiePrefs, defaultPrefs, allAccepted } from "../../utils/cookieConsent";
import CookiePreferencesModal from "./CookiePreferenceModal";
import "./Cookies.scss";
import { useIntl } from "react-intl";
import { PiCookieLight } from "react-icons/pi";
import PropTypes from "prop-types";

export default function CookieBanner({ onChangePrefs }) {
  const { formatMessage } = useIntl();
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const prefs = getCookiePrefs();
    if (!prefs) {
      setShowBanner(true);
    }
  }, []);

  function acceptAll() {
    saveCookiePrefs(allAccepted);
    setShowBanner(false);
    onChangePrefs(allAccepted);
  }

  function rejectNonEssential() {
    saveCookiePrefs(defaultPrefs);
    setShowBanner(false);
    onChangePrefs(defaultPrefs);
  }

  return (
    <>
      {showBanner && (
        <div className="bannerStyle" role="region" aria-label="Cookie consent banner">
          <div>
            <div className="flex cookie-text">
              <div className="flex cookie-icon">
                <PiCookieLight />
              </div>
              <div >
                <strong>{formatMessage({ id: 'cookiesBanner1' })}</strong> {formatMessage({ id: 'cookiesBanner2' })}
              </div>
            </div>
            <a href="/privacy-police" className="link">
              {formatMessage({ id: "newsLetterTerms4" })}
            </a>
          </div>

          <div className="flex cookie-buttons">
            <button className="btnConfig" onClick={() => setShowModal(true)}>
              {formatMessage({ id: 'cookieConfig' })}
            </button>
            <button className="btnPrimary" onClick={rejectNonEssential}>
              {formatMessage({ id: 'cookieReject' })}
            </button>
            <button className="btnSecondary" onClick={acceptAll}>
              {formatMessage({ id: 'cookieAccept' })}
            </button>

          </div>
        </div>
      )}

      {showModal && (
        <CookiePreferencesModal
          onClose={() => setShowModal(false)}
          onSave={() => {
            const prefs = getCookiePrefs();
            setShowModal(false);
            setShowBanner(false);
            onChangePrefs(prefs);
          }}
        />
      )}
    </>
  );
}

CookieBanner.propTypes = {
  onChangePrefs: PropTypes.func.isRequired
};
